import React, { useMemo, useState } from 'react';
import {
  Input,
  LinearProgress,
  FormHelperText,
  FormControl,
  SvgIcon,
} from '@mui/material';
import fileApi from '../../api/file.api';
import { toast } from 'react-toastify';
import {
  Container,
  Description,
  Label,
  RemoveButton,
  Root,
  StyledImage,
} from './style';
import { Close } from '@mui/icons-material';
import _ from 'lodash';
import { mdiTrayArrowUp } from '@mdi/js';

type Props = {
  value?: string | null;
  onChange?: (value?: string | null) => void;
  className?: string;
  style?: React.CSSProperties;
  error?: string;
  inputId?: string;
};

const ImageUploadWithPreview = (props: Props) => {
  const inputId = useMemo(
    () => props.inputId ?? _.uniqueId('image-upload-'),
    [props.inputId],
  );
  const [loading, setLoading] = useState(false);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setLoading(true);
      fileApi
        .upload(file)
        .then((res) => {
          toast.success('Upload successful');
          props.onChange?.(res.data.path);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleRemoveImage = () => {
    props.onChange?.(null);
  };

  return (
    <Root className={props.className} style={props.style}>
      {loading ? (
        <LinearProgress sx={{ height: 4, m: 2, flex: 1 }} color="primary" />
      ) : !props.value ? (
        <Label htmlFor={inputId}>
          <SvgIcon fontSize="large" color="inherit">
            <path d={mdiTrayArrowUp} />
          </SvgIcon>
          <FormControl fullWidth>
            <Description>Click to upload image</Description>
          </FormControl>
          <Input
            id={inputId}
            sx={{
              m: 1,
            }}
            fullWidth
            type="file"
            hidden
            onChange={handleImageChange}
            inputProps={{ accept: 'image/*' }}
            error={!!props.error}
          />
          {props.error ? (
            <FormHelperText error>{props.error}</FormHelperText>
          ) : null}
        </Label>
      ) : (
        <Container>
          <StyledImage src={`${process.env.REACT_APP_API_URI}${props.value}`} />
          <RemoveButton onClick={handleRemoveImage}>
            <Close />
          </RemoveButton>
        </Container>
      )}
    </Root>
  );
};

export default ImageUploadWithPreview;
